import { styled } from '@mui/material';

type ChartVariant = 'default' | 'lastXAxisTickHidden' | 'lastYAxisTickHidden';

export const ChartContainer = styled('div')<{ variant?: ChartVariant }>(({ theme, variant = 'default' }) => ({
  '& .recharts-legend-item svg': {
    width: 16,
    height: 16,
    marginRight: '8px !important',
  },
  '& .recharts-legend-item-text': {
    color: `${theme.palette.text.primary} !important`,
    ...theme.typography['natter-text-sm'],
    fontFamily: theme.typography.fontFamily,
  },
  ...(variant === 'lastXAxisTickHidden' && {
    '& .recharts-cartesian-grid-vertical line:last-of-type': {
      display: 'none',
    },
    '& .xAxis .recharts-cartesian-axis-tick:last-of-type': {
      display: 'none',
    },
  }),
  ...(variant === 'lastYAxisTickHidden' && {
    '& .recharts-cartesian-grid-horizontal line:last-of-type': {
      display: 'none',
    },
    '& .yAxis .recharts-cartesian-axis-tick:last-of-type': {
      display: 'none',
    },
  }),
}));

export const getChartVariant = (orientation: 'vertical' | 'horizontal', showLastTick: boolean): ChartVariant => {
  if (showLastTick) return 'default';
  return orientation === 'horizontal' ? 'lastXAxisTickHidden' : 'lastYAxisTickHidden';
};
